import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  ViewChild,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentIframe} from '@tisa-group/models';

@Component({
  selector: 'tisa-iframe',
  imports: [CommonModule],
  templateUrl: './iframe.component.html',
  styleUrl: './iframe.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IframeComponent {
  readonly component = input<UmpireComponentIframe | undefined>();

  @ViewChild('iframeWrapper', {read: ElementRef}) readonly iframeWrapper:
    | ElementRef
    | undefined;

  ngAfterViewInit(): void {
    if (this.iframeWrapper?.nativeElement) {
      this.iframeWrapper.nativeElement.innerHTML = this.component()?.content;
    }
  }
}
